import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/refer/refer-and-earn.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Invite Friends & Earn Rewards"
				subtitle=""
				breadcrumbText="Refer and Earn"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}